import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Add = createSvgIcon(
  <path d="M13.125 10.875V0h-2.25v10.875H0v2.25h10.875V24h2.25V13.125H24v-2.25H13.125Z" />,
  'Add'
);

export { Add };
